import { EditableSharePermissionList, RoleType } from "@/constants/share";
import RoleSelect from "../RoleSelect";
import { showDialog } from "@/component/Dialog";
import userInfoStore from "@/store/user.store";
import { updateSharePermission, updateShareRemove } from "@/services/share";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import Avatar from "@/component/Avatar";
import { avatarBgs } from "@/constants/record";
import { MeetingSharesItem } from "@/types/share";
interface SharerListProps {
  shareId: string;
  mySharePermission: RoleType;
  sharerList: MeetingSharesItem[];
  setSharerList: (sharerList: MeetingSharesItem[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError: (error: any) => void;
}

const SharerList = ({ shareId, mySharePermission, handleError, sharerList, setSharerList }: SharerListProps) => {
  const company = userInfoStore((state) => state.company);

  const setPermissionChoose = async (
    newRoleType: string,
    targetIndex: number
  ) => {
    try {
      let newSharerList = [...sharerList];
      const targetSharer = sharerList[targetIndex];
      if (newRoleType === RoleType.Removed) {
        await showDialog({
          title: `确认移除${targetSharer.name}吗？`,
          content: "移除后该共享人将无法再查看这篇会记",
          confirmText: "移除",
          cancelText: "取消",
        });
        newSharerList = newSharerList.filter(
          (_item, index) => targetIndex !== index
        );
        await updateShareRemove({
          shareId,
          identityId: targetSharer.identityId,
        });
      } else {
        await updateSharePermission({
          shareId,
          identityId: targetSharer.identityId,
          sharePermission: newRoleType,
        });
        targetSharer.sharePermission = newRoleType;
      }
      setSharerList(newSharerList);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="flex flex-col pt-4 pl-4 pr-1.5 pb-1.5 overflow-hidden">
      <div className="text-3 text-mx-tertiary mb-4">{`共享人(${sharerList.length})`}</div>
      <div className="flex flex-col overflow-auto my-scrollbar pr-1.5">
        {sharerList.map((item, index) => {
          const sharerAvatarInfo = getSpeakerAvatarInfo(item.avatar);
          return (
            <div
              key={item.identityId}
              className="flex items-center justify-between min-h-12 mb-1"
            >
              <div className="flex-1 flex items-center text-#30343C text-3.5">
                <Avatar
                  className="w-8 h-8 text-3 font-600 mr-4"
                  userInfo={{
                    userId: item.identityId,
                    displayName: item.name,
                    avatarUrl: sharerAvatarInfo.avatarUrl,
                    avatarIndex:
                      sharerAvatarInfo.avatarIndex || index % avatarBgs.length,
                  }}
                />
                <div className="max-w-35 mx-text-ellipsis">{`${item.name}`}</div>
                {item.identityId === company?.identityId ? "（我）" : ""}
              </div>
              <div className="min-w-16.5 flex items-center text-3.5 text-mx-tertiary">
                <RoleSelect
                  disabled={
                    !EditableSharePermissionList.includes(mySharePermission) ||
                    item.sharePermission === RoleType.Creator ||
                    item.identityId === company?.identityId
                  }
                  roleType={item.sharePermission}
                  setRoleType={(roleType) =>
                    setPermissionChoose(roleType, index)
                  }
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SharerList;
